import { render, staticRenderFns } from "./projectToContractDialog.vue?vue&type=template&id=b6e27008&scoped=true"
import script from "./projectToContractDialog.vue?vue&type=script&lang=js"
export * from "./projectToContractDialog.vue?vue&type=script&lang=js"
import style0 from "./projectToContractDialog.vue?vue&type=style&index=0&id=b6e27008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e27008",
  null
  
)

export default component.exports